var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31445 6H5.31445H21.3145",
    stroke: "#55575A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3145 6V20C19.3145 20.5304 19.1037 21.0391 18.7287 21.4142C18.3536 21.7893 17.8449 22 17.3145 22H7.31445C6.78402 22 6.27531 21.7893 5.90024 21.4142C5.52517 21.0391 5.31445 20.5304 5.31445 20V6M8.31445 6V4C8.31445 3.46957 8.52517 2.96086 8.90024 2.58579C9.27531 2.21071 9.78402 2 10.3145 2H14.3145C14.8449 2 15.3536 2.21071 15.7287 2.58579C16.1037 2.96086 16.3145 3.46957 16.3145 4V6",
    stroke: "#55575A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3145 11V17",
    stroke: "#55575A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3145 11V17",
    stroke: "#55575A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/trash-2.5949d4b020d710972cb5ab1311f66e8f.svg";
export { ForwardRef as ReactComponent };